"use strict";

var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");

var moment = require("moment");
var cx = require("classnames");
var dateFormat = "DD MMM, YYYY";
var dateFormFormat = "YYYY-MM-DD";
moment.locale("pt-br");

var DateRangeFilter = React.createClass({
  getInitialState: function() {
    var state = {
      filterType: (this.props.filters.dateRange ? this.props.filters.dateRange : "ALL") /* ALL, WEEK, TODAY, CUSTOM */
    };
    if (this.props.filters.dateRange && this.props.filters.dateRange === "CUSTOM") {
      state.dtInicial = this.props.filters.dtInicial;
      state.dtFinal = this.props.filters.dtFinal;
    }
    return state;
  },
  onCustomDateSelected: function(dateKey, dateValue) {
    this.props.setFilter("offset", 0, true);
    this.props.setFilter(dateKey, dateValue, false);
    this.setState({
      dateKey: dateValue
    });
  },
  handleChangeFilterType: function(type, dtInicial, dtFinal) {
    this.setState({
      filterType: type
    });
    this.props.setFilter("offset", 0, true);
    this.props.setFilter("dtInicial", dtInicial, true);
    this.props.setFilter("dtFinal", dtFinal, true);
    this.props.setFilter("dateRange", type, false);
    if (type == "CUSTOM") {
      this.setState({
        dtInicial: dtInicial,
        dtFinal: dtFinal
      });
    }
  },
  render: function() {
    var filters;
    if (this.state.filterType != "CUSTOM") {
      filters = <DefaultFilters {...this.state} handleChangeFilterType={this.handleChangeFilterType}/>;
    } else {
      filters = <CustomFilter {...this.state} handleChangeFilterType={this.handleChangeFilterType}
                                              onCustomDateSelected={this.onCustomDateSelected}/>;
    }
    return (
      <div className="dateRange-filter" id="periodoPicker">
        {filters}
      </div>
    );
  }
});

var DefaultFilters = React.createClass({
  render: function () {
    return (
      <ButtonGroup>
        <FilterAllButton filterType={this.props.filterType} onChange={this.props.handleChangeFilterType} />
        <FilterWeekButton filterType={this.props.filterType} onChange={this.props.handleChangeFilterType} />
        <FilterTodayButton filterType={this.props.filterType} onChange={this.props.handleChangeFilterType} />
        <FilterCustomButton filterType={this.props.filterType} onChange={this.props.handleChangeFilterType} />
      </ButtonGroup>
    );
  }
});

var CustomFilter = React.createClass({
  componentDidMount: function() {
    this.startDatepicker();
  },
  componentDidUpdate: function() {
    this.startDatepicker();
  },
  startDatepicker: function() {
    var onCustomDateSelected = this.props.onCustomDateSelected;
    $("#dtInicial, #dtFinal").datepicker({
      dateFormat:"dd M, yy",
      onSelect: function(dateText, inst) {
        var date = moment([inst.selectedYear, inst.selectedMonth, inst.selectedDay]).format(dateFormFormat);
        onCustomDateSelected(inst.id, date);
        $(this).datepicker("hide").blur();
      }
    });
  },
  render: function () {
    var inputClassName = cx("btn", "btn-filter", "btn-label", "c-text", "selected", "clickable", "w-110");
    var labelClassName = cx("btn", "btn-filter", "btn-label", "selected");
    var dtInicialFormatted = moment(this.props.dtInicial).format(dateFormat);
    var dtFinalFormatted = moment(this.props.dtFinal).format(dateFormat);
    return (
      <ButtonGroup>
        <input type="text" className={inputClassName} defaultValue={dtInicialFormatted} id="dtInicial" spellCheck="false" />
        <span className={labelClassName}>at&eacute;</span>
        <input type="text" className={inputClassName} defaultValue={dtFinalFormatted} id="dtFinal" spellCheck="false" />
        <FilterAllButton filterType={this.props.filterType} onChange={this.props.handleChangeFilterType} title="cancelar" />
      </ButtonGroup>
    );
  }
});

var FilterAllButton = React.createClass({
  getDefaultProps: function () {
    return {
      title: "Todas"
    };
  },
  render: function () {
    var dtInicial = null;
    var dtFinal = null;
    return (
      <FilterButton {...this.props} type="ALL" title={this.props.title} dtInicial={dtInicial} dtFinal={dtFinal}/>
    );
  }
});

var FilterWeekButton = React.createClass({
  render: function () {
    var dtInicial = moment().day(0).format(dateFormFormat);
    var dtFinal = moment().day(6).format(dateFormFormat);
    return (
      <FilterButton {...this.props} type="WEEK" title="Esta semana" dtInicial={dtInicial} dtFinal={dtFinal}/>
    );
  }
});

var FilterTodayButton = React.createClass({
  render: function () {
    var dtInicial = moment().format(dateFormFormat);
    var dtFinal = moment().format(dateFormFormat);
    return (
      <FilterButton {...this.props} type="TODAY" title="Hoje" dtInicial={dtInicial} dtFinal={dtFinal}/>
    );
  }
});

var FilterCustomButton = React.createClass({
  render: function () {
    var dtInicial  = moment().date(1).format(dateFormFormat);
    var dtFinal = moment().date(0).add(1, "M").format(dateFormFormat);
    return (
      <FilterButton {...this.props} type="CUSTOM" title="definir" dtInicial={dtInicial} dtFinal={dtFinal}/>
    );
  }
});

var FilterButton = React.createClass({
  componentDidMount: function () {
    if (this.props.type == this.props.filterType) {
      this.fireChange();
    }
  },
  onClick: function (e) {
    e.preventDefault();
    this.fireChange();
  },
  fireChange: function () {
    this.props.onChange(this.props.type, this.props.dtInicial, this.props.dtFinal);
  },
  render: function () {
    var className = (this.props.type == this.props.filterType ? "selected": "");
    return (
      <Button onClick={this.onClick} type="filter" className={className}>
        <span>{this.props.title}</span>
      </Button>
    );
  }
});


module.exports = DateRangeFilter;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/date-range-filter.jsx